import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {CommonModule, DOCUMENT, isPlatformBrowser, ViewportScroller} from '@angular/common';
import {BaseSectionComponent} from "../base-section/base-section.component";
import {TinyPostComponent} from "../../elements/tiny-post/tiny-post.component";
import {TinyPostsFromIdsPipe} from "../../../pipes/tinyPostFromId/tiny-post-from-id.pipe";
import {PageSelectionSitSection} from "../../../models/Page/Sections/PageSelectionSitSection";
import {SynapiListItemsComponent} from "../../elements/synapi-list-items/synapi-list-items.component";
import {SynapiMapComponent} from "../../elements/synapi-map/synapi-map.component";
import {SynapiPredicate} from "../../../models/Synapi/SynapiPredicate";
import {SynapiService} from "../../../services/synapi.service";
import {SynapiListItems} from "../../../models/Synapi/SynapiListItems";
import {CustomSearchInputComponent} from "../../elements/inputs/custom-search-input/custom-search-input.component";
import {NgxSmartModalModule, NgxSmartModalService} from "ngx-smart-modal";
import {SynapiFiltersComponent} from "../../elements/synapi-filters/synapi-filters.component";
import {SynapiFilters} from "../../../models/Synapi/SynapiFilters";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {SynapiDatepickersComponent} from "../../elements/synapi-datepickers/synapi-datepickers.component";
import {Period} from "../../../models/Misc/Period";

@Component({
  selector: 'selection-sit-section',
  standalone: true,
  imports: [CommonModule, BaseSectionComponent, RouterLink, TinyPostComponent, TinyPostsFromIdsPipe, SynapiListItemsComponent, SynapiMapComponent, CustomSearchInputComponent, NgxSmartModalModule, SynapiFiltersComponent, FormsModule, SynapiDatepickersComponent],
  templateUrl: './selection-sit-section.component.html',
  styleUrl: './selection-sit-section.component.scss'
})
export class SelectionSitSectionComponent extends BaseSectionComponent<PageSelectionSitSection> implements AfterViewInit, OnInit{

  public mapPredicate: SynapiPredicate = new SynapiPredicate();
  public listPredicate: SynapiPredicate = new SynapiPredicate();
  public filterPredicate: SynapiPredicate = new SynapiPredicate();
  public mapItems : SynapiListItems;
  public listItems : SynapiListItems;
  public filtersTree : SynapiFilters;
  public filterModal : SynapiFilters;
  public textsearch: string;
  public start: Date;
  public end: Date;
  public total: number;
  public filters : string[] = [];

  @Input() itemsPerSlide : number = 10;
  @ViewChild("map") mapRef?: SynapiMapComponent;
  @ViewChild("list") listRef?: SynapiListItemsComponent;
  @ViewChild("datepicker") datepickerRef?: SynapiDatepickersComponent;
  @ViewChild("filters") filtersRef?: SynapiFiltersComponent;
  @ViewChild("filtersSelected") filtersSelectedRef?: SynapiFiltersComponent;
  isMobileActive = false;
  isGeolocationActive = false;

  constructor(
    private viewportScroller: ViewportScroller,
    private vcr: ViewContainerRef,
    public synapi: SynapiService,
    public ngxSmartModalService: NgxSmartModalService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private doc: Document,
  ) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    const compositeFragment = this.router.parseUrl(this.router.url).fragment;
    this.parseCompositeFragment(compositeFragment);
    if(!this.sectionRendered.has_hide_map){
      this.sectionRendered.has_hide_filters = false;
    }
  }

  ngAfterViewInit() {
    this.listPredicate.page = 1;
    if(this.textsearch){
      this.listPredicate.textsearch = this.textsearch;
    }
    if(!this.sectionRendered.has_hide_map){
      this.mapPredicate.id = this.sectionRendered.selection_sit;
      if(this.filters){
        this.mapPredicate.ids = this.filters;
      }
      this.listPredicate.size = 9;
      this.itemsForMap();
    } else {
      this.listPredicate.id = this.sectionRendered.selection_sit;
      this.listPredicate.size = 10;
      this.itemsForList();
    }
    if(!this.sectionRendered.has_hide_filters){
      this.filterPredicate.ids = []
      if(this.filters){
        this.filterPredicate.ids = this.filters.filter((f)=>!this.filterPredicate.ids.includes(f)).concat(this.filterPredicate.ids);
      }
      this.filterPredicate.ids.push(this.sectionRendered.selection_sit);
      this.itemsForFilters();
    }
  }

  async itemsForList(isExternalChange= true){
    if(this.listRef){
      this.listRef.loading = true;
      this.listItems = await this.synapi.getItems(this.listPredicate);
      if(isExternalChange){
        this.listRef.reset();
      };
      this.setTotal();
      this.listRef.updateListItems(this.listItems);
    }
  }
  async itemsForMap(){
    this.mapItems = await this.synapi.getSmallItems(this.mapPredicate);
    this.mapRef?.setAllMarkers();
  }

  async itemsForFilters(){
    this.filtersTree = await this.synapi.getFilters(this.filterPredicate);
    if(this.filtersRef){
      this.filtersRef.filtersTree = this.filtersTree;
    }
    if(this.filtersSelectedRef){
      this.filtersSelectedRef.filtersTree = this.filtersTree;
    }
  }

   onMapPredicateChange($event: SynapiPredicate){
    this.listPredicate.ids = $event.elements;
     this.listPredicate.textsearch = "";
     this.listPredicate.page = 1;
      this.itemsForList();
  }

   async onListPredicateChange($event: SynapiPredicate) {
     this.listPredicate.page = $event.page;
     await this.itemsForList(false);
   }

  async onFilterPredicateChange($event: SynapiPredicate) {
    this.mapPredicate.ids = $event.ids;
    this.textsearch = "";
    await this.navigate();
    await this.itemsForMap();
    await this.itemsForFilters();
    this.datepickerRef?.reset();
  }

  async onSearch($event: string){
    const normalize =  (str: string) => {
      if(!str) str = "";
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    }

    this.textsearch = normalize($event);
    await this.itemsForMap()
    this.mapItems.items = this.mapItems.items.filter((i)=>
      normalize(i.Title).includes(this.textsearch) ||
      normalize(i.Description).includes(this.textsearch) ||
      (i.AdressePrincipale?.Commune && normalize(i.AdressePrincipale.Commune).includes(this.textsearch))
    );
    await this.navigate();
  }

  async navigate() {
    await this.router.navigate([], {fragment: this.mergeFragments(), relativeTo: this.route})
    this.scroll();
  }

  onFilterClick(){
    this.ngxSmartModalService.getModal('SelectionSitFilters'+this.index).open();
  }

  mergeFragments(){
    const fragments: any[] = [];
    if(this.textsearch){
      fragments.push(`textsearch=${this.textsearch}`);
    }
    if(this.filterPredicate.ids.length>1){
      fragments.push(`filters=${this.filterPredicate.ids.filter((id)=> id != this.sectionRendered.selection_sit).join(',')}`);
    }
    if(this.mapPredicate.datemin){
      fragments.push(`start=${this.mapPredicate.datemin}`);
    }
    if(this.mapPredicate.datemax){
      fragments.push(`end=${this.mapPredicate.datemax}`);
    }
    return fragments.join(":");
  }

  parseCompositeFragment(compositeFragment: string | null) {
    if (compositeFragment) {
      const fragments = compositeFragment.split(':');
      fragments.forEach( fragment => {
        const [key, value] = fragment.split('=');
        if (key === 'filters') {
          this.filters = value.split(',');
        }
        if (key === 'start') {
          this.start = new Date(value);
        }
        if (key === 'end') {
          this.end = new Date(value);
        }
        if (key === 'textsearch') {
          setTimeout(()=>{
             this.onSearch(value);
          },1000);

        }
        this.scroll();
      });

    }
  }

  scroll(){
    if(isPlatformBrowser(this.platformId)){
      setTimeout(()=>{
        if(this.filters || this.textsearch){
          const headerNav = this.doc.getElementById("HeaderNavbar");
          const offset = this.vcr.element.nativeElement.offsetTop - (headerNav?.clientHeight??0);
          this.viewportScroller.scrollToPosition([0,offset])
        }
      },0)
    }
  }

  setTotal($event?:number){
    if($event){
      this.total = $event;
      return;
    }
    if(this.mapItems?.items.length >=0){
      this.total = this.mapItems?.items.length;
      return;
    }
  }

  onPeriodChange($event: Period) {
    if(!this.mapPredicate.id) this.mapPredicate.id = this.sectionRendered.selection_sit;
    this.mapPredicate.datemin = $event.start.toLocaleDateString("fr-CA",{year:"numeric", month:"2-digit", day:"2-digit"});
    this.mapPredicate.datemax = $event.end.toLocaleDateString("fr-CA",{year:"numeric", month:"2-digit", day:"2-digit"});
    this.navigate();
    this.itemsForMap();
  }
}
